export default __webpack_public_path__ + "static/media/download.10c22b05.gif";